import { render, staticRenderFns } from "./materialRow.vue?vue&type=template&id=1675ce9d"
import script from "./materialRow.vue?vue&type=script&lang=js"
export * from "./materialRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports